import { useTranslation } from '@ecomm/i18n'

export function AvailableTime() {
  const { t } = useTranslation('header')

  return (
    <div className="flex items-center mt-2">
      <div className="h-2 w-2 bg-complementary-sage-100 border-solid border border-gray-800 rounded" />
      <span className="ml-1 text-sm font-normal opacity-90">
        {t('call-specialist-dropdown-menu.available-time')}
      </span>
    </div>
  )
}
